import { Tags } from "../../../shared/models/tags.model.ts";
import { getToken } from "../../../shared/utils/common.tsx";
import { TagSerializer } from "../serializers/tagSerializer.ts";

export class CommandGetTags {
    async run(tagGroupId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/core/tag_groups/${tagGroupId}/tags/`
        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {'Content-Type': 'application/json', "Authorization": `Token ${getToken()} `}
                })
            .then(response =>  response.json())
            .then(json => json)
            .catch(err => console.log(err));
            if(response) {
                return this.deserialize(response);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any): Tags[] {
        const serializer = new TagSerializer();
        return serializer.deserializeList(data);
    }
}
